import { render } from "./GradientText.vue?vue&type=template&id=35b600fa&scoped=true"
import script from "./GradientText.vue?vue&type=script&lang=js"
export * from "./GradientText.vue?vue&type=script&lang=js"

import "./GradientText.vue?vue&type=style&index=0&id=35b600fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b600fa"]])

export default __exports__